import { DEFAULT_FETCH_INTERVAL_IN_SECONDS } from '../constants/app-constants';

export default class AppDataModel {
  constructor() {
    this.guid = '';
    this.isRequestsThrottled = false;
    this.dataError = false;
    this.retryLoadingDynamicDataTimes = 0;
    this.isExpiredGuid = false;

    // New
    // TODO:: rename to trip data instead - @wesley.loh
    this.isLoadingInitData = false;
    this.isLoadedInitData = false;
    this.isErrorInitData = false;

    // Not using now
    this.isLoadingFullData = false;
    this.isLoadedFullData = false;
    this.isErrorFullData = false;

    // Not using now
    this.isLoadingDynamicData = false;
    this.isLoadedDynamicData = false;
    this.isErrorDynamicData = false;

    this.trackingInterval = null;
    this.fetchInterval = DEFAULT_FETCH_INTERVAL_IN_SECONDS;
    this.featureFlag = 0;

    this.enableInstruction = false;
    this.enableWebTrackingUICashlessPOD = false;
  }
}
